/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDisabled2 = createReactComponent("disabled-2", "IconDisabled2", [
  ["path", { d: "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M9 11a5 5 0 1 0 3.95 7.95", key: "svg-1" }],
  ["path", { d: "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1", key: "svg-2" }]
]);

export { IconDisabled2 as default };
//# sourceMappingURL=IconDisabled2.js.map
